"use client";

import { Info } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

type PlatformEmailDefaultBannerProps = {
  variant: "quote" | "booking";
  fromAddress: string;
  description?: string;
};

export function PlatformEmailDefaultBanner({
  variant,
  fromAddress,
  description,
}: PlatformEmailDefaultBannerProps) {
  const defaultDescription =
    variant === "quote"
      ? "Quote emails are sent automatically using the TA Desk default. Configure a custom delivery method below to use your own domain."
      : "Booking emails and customer replies work automatically using the TA Desk default. Add your own domain below to upgrade.";

  return (
    <Alert className="border-sky-200 bg-sky-50 dark:border-sky-900/50 dark:bg-sky-950/20">
      <Info className="h-4 w-4 text-sky-600 dark:text-sky-400" />
      <AlertDescription className="space-y-2 text-sm">
        <p>{description ?? defaultDescription}</p>
        <p>
          Current default From address:{" "}
          <code className="rounded bg-sky-100 px-1 dark:bg-sky-900/40">
            {fromAddress}
          </code>
        </p>
      </AlertDescription>
    </Alert>
  );
}
